import { render, staticRenderFns } from "./filterPropositionsElec.vue?vue&type=template&id=0fb963f3&scoped=true"
import script from "./filterPropositionsElec.vue?vue&type=script&lang=js"
export * from "./filterPropositionsElec.vue?vue&type=script&lang=js"
import style0 from "./filterPropositionsElec.vue?vue&type=style&index=0&id=0fb963f3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb963f3",
  null
  
)

export default component.exports